import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/Dashboard";
import LeadScanner from "./pages/LeadScanner";
import WebsiteGenerator from "./pages/WebsiteGenerator";
import LeadManager from "./pages/LeadManager";
import WebsiteGallery from "./pages/WebsiteGallery";
import LaunchKit from "./pages/LaunchKit";
import NicheSearch from "./pages/NicheSearch";
import LoginPage from "./pages/LoginPage";
import LandingPage from "./pages/LandingPage";
import TranslatorPage from "./pages/TranslatorPage";

function AdminDashboard() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F7]">
        <div className="spinner" style={{ width: 28, height: 28 }} />
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <div className="flex min-h-screen bg-[#F5F5F7]">
      <Sidebar />
      <main className="flex-1 p-4 md:p-6 lg:p-8 overflow-auto">
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/scanner" element={<LeadScanner />} />
          <Route path="/dashboard/niche-search" element={<NicheSearch />} />
          <Route path="/dashboard/generator" element={<WebsiteGenerator />} />
          <Route path="/dashboard/leads" element={<LeadManager />} />
          <Route path="/dashboard/websites" element={<WebsiteGallery />} />
          <Route path="/dashboard/launch" element={<LaunchKit />} />
          <Route path="/dashboard/translator" element={<TranslatorPage />} />
        </Routes>
      </main>
    </div>
  );
}

function AppContent() {
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  if (isDashboard) {
    return <AdminDashboard />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
        <Toaster position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
